export const sanitizeTagText = (value) => (value || '').replace(/["<>]/g, '').trim();

export const questionTag = (visual, prompt) =>
  `<question visual="${sanitizeTagText(visual)}">${sanitizeTagText(prompt)}</question>`;

export const productFeedTag = (feedId, title) => {
  const cleanId = sanitizeTagText(String(feedId ?? ''));
  const cleanTitle = sanitizeTagText(title);
  return cleanTitle ? `<productfeed id="${cleanId}" title="${cleanTitle}" />` : `<productfeed id="${cleanId}" />`;
};

// The type names an action in the chat bot's settings; the widget runs it with its fixed parameters.
export const actionTag = (type) => `<action type="${sanitizeTagText(type)}" />`;

export const appendTag = (message, tag) => (message ? `${message.replace(/\s+$/, '')}\n\n${tag}` : tag);
